module.exports = __webpack_public_path__ + "static/media/vuepaylogonav@5x.beed135a.png";